import React, { Component } from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import { StyledRegulation } from './info.styles'

class RebookingPage extends Component {
	render() {
		const { history } = this.props

		return (
			<Container style={{ paddingBottom: '5rem' }}>
				<Title>
					<span className="bold">Guia de Orientação aos Passageiros</span>
				</Title>
				<StyledRegulation>
					<div>
						<h3>Guias de Orientação aos Passageiros</h3>
						<p>
							Bem-vindo ao campo Guias de Orientação aos Passageiros das
							Transportadoras parceiras do Muviflex!
						</p>
						<p>
							Este espaço foi criado para fornecer informações detalhadas
							e atualizadas dos Guias de Orientação aos Passageiros das
							Transportadoras parceiras do Muviflex, em conformidade com
							a Resolução ANTT Nº 6.033, de 21 de dezembro de 2023. Nosso
							objetivo é garantir que todos os passageiros estejam
							cientes das informações essenciais para uma viagem segura e
							tranquila, com um atendimento personalizado.
						</p>
						<p>
							Para informações sobre cada transportadora parceira, acesse
							os guias individuais nos links abaixo:
						</p>
						<ul>
							<li>
								Guia de Orientação aos Passageiros da Planalto
								Transportes:{' '}
								<a href="https://planalto.com.br/informacoes-ao-passageiro/">
									Informações ao Passageiro - Planalto Transportes
								</a>
							</li>
							<li>
								Guia de Orientação aos Passageiros da Unesul:{' '}
								<a href="https://www.unesul.com.br/site/default.asp?TroncoID=945181&SecaoID=627437&SubsecaoID=0">
									Guia de Orientações - Viagem - Unesul
								</a>
							</li>
							<li>
								Guia de Orientação aos Passageiros da Viação Cometa:{' '}
								<a href="https://www.viacaocometa.com.br/informacaoaopassageiro">
									Informação ao Passageiro (viacaocometa.com.br)
								</a>
							</li>
							<li>
								Guia de Orientação aos Passageiros da Viação
								Catarinense:{' '}
								<a href="https://www.catarinense.com.br/informacaoaopassageiro">
									Informação ao Passageiro (catarinense.com.br)
								</a>
							</li>
							<li>
								Guia de Orientação aos Passageiros da Viação 1001:{' '}
								<a href="https://www.autoviacao1001.com.br/informacaoaopassageiro">
									Informação ao Passageiro (autoviacao1001.com.br)
								</a>
							</li>
							<li>
								Guia de Orientação aos Passageiros da Rápido Ribeirão
								Preto:{' '}
								<a href="https://www.rapidoribeiraopreto.com.br/informacaoaopassageiro">
									Informação ao Passageiro (rapidoribeiraopreto.com.br)
								</a>
							</li>
							<li>
								Guia de Orientação aos Passageiros da Expresso do Sul:{' '}
								<a href="https://www.expressodosul.com.br/informacaoaopassageiro">
									Informação ao Passageiro (expressodosul.com.br)
								</a>
							</li>
						</ul>
						<p>
							<strong>Importante:</strong> Os Guias de Orientação aos
							Passageiros são destinados exclusivamente para viagens
							interestaduais!
						</p>
						<p>
							Nosso compromisso é proporcionar uma experiência de viagem
							confortável e segura, com atendimento personalizado e
							adaptado às necessidades de cada passageiro.
						</p>
					</div>
				</StyledRegulation>
			</Container>
		)
	}
}

export { RebookingPage as ModuleRootComponent }
